<template>
    <div>
        <app-sub-title :text="'Usuarios del cliente ' + client.name" />
        <div class="mb-3">
            <b-button variant="primary" @click="openForm">
                <i class="fa fa-plus"></i> Crear usuario
            </b-button>
        </div>
        <app-client-users-filters
            @filter="onFilter"
        />
        <app-client-users-list
            :data="data"
            @change-page="onChangePage"
            @remove-user="startRemove"
            @edit-user="onEditUser"
            @sort="onSort"
        />

        <app-pop-up
            :title="selectedUser ? 'Editar usuario' : 'Crear usuario'"
            :id="userFormPopUpId"
            :on-close="closeForm"
        >
            <div slot="body">
                <app-client-user-form
                    ref="clientUserForm"
                    :selected-user="selectedUser"
                    :client-context="client"
                    :on-save="onUserSaved"
                />
            </div>
            <div class="buttons" slot="buttons">
                <b-btn variant="primary" @click="submitForm"><i class="fa fa-save"></i> Guardar</b-btn>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="user-client-remove">
            <div slot="body">
                <h2 v-if="isRemovingContractor">¿Desea desvincular este contratista del cliente?</h2>
                <p v-if="isRemovingContractor" class="text-muted mb-0">
                    El usuario no se eliminará del sistema; se quitarán los documentos cargados para este cliente y la vinculación en contractor_client.
                </p>
                <h2 v-else>¿Está seguro que desea eliminar este usuario?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <b-btn variant="danger" @click="deleteUser(selectedUser)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar</b-btn>
            </div>
        </app-pop-up>
    </div>
</template>

<script>
import ClientUsersList from './ClientUsersList/ClientUsersList';
import ClientUsersFilters from './ClientUsersFilters/ClientUsersFilters';
import ClientUserForm from './ClientUserForm/ClientUserForm.vue';
import userRepository from '../../../repositories/users.repository.js';
import { mapGetters } from 'vuex';

export default {
    components: {
        appClientUsersList: ClientUsersList,
        appClientUsersFilters: ClientUsersFilters,
        appClientUserForm: ClientUserForm
    },
    data() {
        return {
            data: {},
            filters: {},
            sort: { sortBy: 'created_at', sortDir: 'desc' },
            page: 1,
            selectedUser: null,
            userFormPopUpId: 'client-user-form-popup'
        };
    },
    computed: {
        ...mapGetters(['client']),
        isRemovingContractor() {
            const u = this.selectedUser;
            return !!(u && u.profile && u.profile.slug === 'contractor');
        }
    },
    methods: {
        loadUsers() {
            const ur = Object.assign({}, userRepository);
            ur
                .all({...this.filters, client: this.client.id}, this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar los usuarios del cliente')
                );
        },
        onFilter(filters){
            this.filters = filters;
            this.loadUsers();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadUsers();
        },
        onChangePage(page){
            this.page = page;
            this.loadUsers();
        },
        startRemove(user) {
            this.selectedUser = user;
            this.$bus.$emit('user-client-remove.open');
        },
        deleteUser(user) {
            if (!user) return;
            const ur = Object.assign({}, userRepository);
            const slug = user.profile && user.profile.slug;
            const req = slug === 'contractor' ? ur.removeClientUserFromClient(user.id) : ur.deleteUser(user.id);
            req
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadUsers();
                        this.$bus.$emit('user-client-remove.close');
                        this.selectedUser = null;
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(() => {
                    toastr.error('No se pudo borrar el usuario del cliente');
                });
        },
        openForm() {
            this.selectedUser = null;
            this.$bus.$emit(this.userFormPopUpId + '.open');
        },
        closeForm() {
            this.selectedUser = null;
            this.$bus.$emit(this.userFormPopUpId + '.close');
        },
        onEditUser(user) {
            this.selectedUser = user;
            this.$bus.$emit(this.userFormPopUpId + '.open');
        },
        submitForm() {
            if (this.$refs.clientUserForm) {
                this.$refs.clientUserForm.save();
            }
        },
        onUserSaved() {
            this.closeForm();
            this.loadUsers();
        }
    },
    created() {
        this.loadUsers();
    }
};
</script>
